type Query = Record<string, string>;

export const linkedInSearchUrl = (query: Query) => {
  const url = new URL("https://www.linkedin.com/search/results/all/");
  url.search = new URLSearchParams(query).toString();
  return url.toString();
};

export const fullInternalUrl = (path: string) => {
  if (!path.startsWith("/")) path = `/${path}`;
  const appDomain = import.meta.env.VITE_APP_HOST;
  return `${appDomain}${path}`;
};
